const BizIndex =
{
  biz1: 
  {
    id          : 1,
    exist       : true,
    paid        : true,
  },
  biz2: 
  {
    id          : 2,
    exist       : true,
    paid        : true,
  },
  biz3: 
  {
    id          : 3,
    exist       : true,
    paid        : true,
  },
  biz4: 
  {
    id          : 4,
    exist       : true,
    paid        : true,
  },
}

export default BizIndex;